/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {MediaTypeHelper} from '../../../components/util/media-type-helper';
import vastLoadTemplate from './examples/vast-load.html';
import parallaxLoadTemplate from './examples/parallax-load.html';

export function translateLayoutComponentMediaTypes(mimeTypes: string | string[], translate: (key: string) => string): string {
  const types = _.isArray(mimeTypes) ? mimeTypes : [mimeTypes];
  const mediaTypes = _.map(types, (mimeType) => MediaTypeHelper.getMediaType(mimeType));
  const translations = _.map(_.uniq(_.compact(mediaTypes)), (mediaType) => translate('media.' + mediaType.id));
  return translations.join(', ');
}

export function setupLayoutExamplePreview(
  model: any,
  iframeContainer: HTMLElement,
  window: Window
): void {
  if (model.vastUrl) {
    setupLayoutExampleIframe(iframeContainer, vastLoadTemplate.replace('{VAST_URL}', model.vastUrl));
    return;
  }

  if (model.id === 'parallax-layout-example') {
    setupLayoutExampleIframe(iframeContainer, parallaxLoadTemplate);
    return;
  }

  const adnWindow = window as any;
  adnWindow.adn = adnWindow.adn || {};
  adnWindow.adn.calls = adnWindow.adn.calls || [];
  adnWindow.adn.calls.push(function() {
    adnWindow.adn.request({
      env: 'production',
      network: '5c',
      adUnits: [{
        targetId: 'ad-container',
        auId: '7eb8e',
        auW: '500',
        auH: '600',
        kv: {examples: [model.kv]}
      }]
    });
  });
}

function setupLayoutExampleIframe(container: HTMLElement, template: string): void {
  const iframe = document.createElement('iframe');
  iframe.setAttribute('allowTransparency', 'true');
  iframe.setAttribute('id', 'iframe-window');
  iframe.setAttribute('width', '440');
  iframe.setAttribute('height', '440');
  iframe.frameBorder = '0';

  container.appendChild(iframe);

  const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
  if (!iframeDoc) {
    return;
  }
  iframeDoc.open();
  iframeDoc.write(template);
  iframeDoc.close();

  const bodyElement = iframeDoc.querySelector('body');
  if (bodyElement) {
    bodyElement.setAttribute('style', 'margin: 0; padding: 0;');
  }
}
